export const environment = {
    urls: {
        validatePhone: '/index.php?route=module/check_phone/phone/validatePhoneAndSendCode',
        isVerificate: 'index.php?route=module/check_phone/phone/checkVerificationPhone',
        checkCodeAndAuth: '/index.php?route=module/check_phone/phone/validatePhoneAndAuthenticateUser',
        checkCode: '/index.php?route=module/check_phone/phone/validateCode',
        registration: '/index.php?route=module/check_phone/phone/registrationClient',
        registrationFacebook: '/index.php?route=module/check_phone/phone/registrationClientFacebook',
        registrationGoogle: '/index.php?route=module/check_phone/phone/registrationClientGoogle',
        orders: '/index.php?route=account/orders/orders',
        order: '/index.php?route=account/order/order',
        notifications: '/index.php?route=account/notifications/all',
        notificationsUpdate: '/index.php?route=account/notifications/update',
        user: '/index.php?route=account/account/user',
        me: '/index.php?route=account/account/me',
        userSave: '/index.php?route=account/account/save',
        credits: {
            init: '/index.php?route=module/credit_calculator/init',
            recalculate: '/index.php?route=module/credit_calculator/recalculate',
            shippingMethods: '/index.php?route=module/credit_calculator/shippingMethods',
            getCities: '/index.php?route=module/credit_calculator/cities',
            getRegions: '/index.php?route=module/credit_calculator/regions',
            getPickups: '/index.php?route=module/credit_calculator/pickups',
            fetchTotal: '/index.php?route=module/credit_calculator/total',
            order: '/index.php?route=module/credit_calculator/order',
        },
        validEmail: '/index.php?route=module/credit_calculator/email',
        product: {
            fetchProduct: '/index.php?route=product/fetcher/getCropData',
        },
    },
    routesUrls: {
        account: '/index.php?route=account/account',
        logout: '/index.php?route=account/logout',
        orders: '/index.php?route=account/orders',
        order: '/index.php?route=account/order',
        notifications: '/index.php?route=account/notifications',
        profile: '/index.php?route=account/profile',
    },
    facebookClientId: '787763566522030',
    googleKey: '17735602987-0p15o6i7deoaiq3r2j8ijmu9fvdrhikp.apps.googleusercontent.com'
}